<template>
	<!--
		@todo Both the plugin and dashboard use the nearly identical common-transition-slide components.
		When we introduce this to the dashboard, let's unify them here in the library.
	-->
	<common-transition-slide :active="active" class="playbooks-filter__options">
		<div class="filters-top">
			<div class="filters-left">
				<div
					v-for="(options, filter) in filtersToShow"
					:key="filter"
					:class="`playbooks-filter__filter-${filter} om-checkbox-group`"
				>
					<!-- We are using CSS to capitalize the filter heading-->
					<strong>{{ filter }}</strong>
					<div>
						<label
							v-for="option in options"
							:key="option.id"
							@input="setTaxonomyFilter(filter, option)"
							class="om-checkbox"
						>
							<input :value="option.id" :checked="filterSet(filter, option)" type="checkbox" />
							<span class="om-checkbox__input" />
							{{ option.name }}
						</label>
					</div>
				</div>
				<div class="filters-right">
					<playbooks-filter-did-you-know />
				</div>
			</div>
		</div>
		<div class="filters-bottom">
			<button :disabled="!isFiltering" @click="clearFilters" type="button" class="button medium">
				Clear Filters
			</button>
		</div>
	</common-transition-slide>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { filtering } from 'optinmonster-js-library/src/vue/playbooks/mixins/filtering';

export default {
	mixins: [filtering],
	props: {
		active: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		...mapState('playbooks', ['filterOptions']),
		...mapGetters('playbooks', ['hasGamifiedPlaybooks']),
		/**
		 * Determine which filters to show to the user.
		 *
		 * @returns {Object} The filter types and their possible values
		 */
		filtersToShow() {
			let filters = {};
			this.filterOptions.forEach((o) => {
				// We aren't using the device filter and skip that one
				if ('device' !== o.slug) {
					if ('tags' === o.slug && this.hasGamifiedPlaybooks) {
						filters[o.slug] = o.values.filter((o) => 'Featured' !== o.name);
					} else {
						// Remove any options with no Playbooks
						filters[o.slug] = o.values.filter((o) => {
							return 0 < o.playbooks_count;
						});

						if (0 === filters[o.slug].length) {
							delete filters[o.slug];
						}
					}
				}
			});
			// Sort the key values alphabetically
			filters = Object.keys(filters)
				.sort()
				.reduce((result, key) => {
					result[key] = filters[key];
					return result;
				}, {});
			return filters;
		},
	},
	methods: {
		/**
		 * Saves the passed filter type and value to state
		 *
		 * @param {string} filter The type of filter we are setting
		 * @param {string} option The filter value we are setting
		 *
		 * @returns {void}
		 */
		setTaxonomyFilter(filter, option) {
			const value = [...this.filters[filter]];
			const index = value.indexOf(option.id);
			if (-1 !== index) {
				value.splice(index, 1);
			} else {
				value.push(option.id);
			}

			this.$store.commit('playbooks/setFilter', { filter, value: value });
		},
		/**
		 * Determine if the passed filter and option is set
		 *
		 * @param {string} filter The type of filter we are looking for
		 * @param {string} option The filter value we are looking for
		 *
		 * @returns {boolean} Whether or not the current filter set includes the supplied filter type and value
		 */
		filterSet(filter, option) {
			return this.filters[filter].includes(option.id);
		},
	},
};
</script>
